import { Box } from '@mui/material'
import ProfileBlock from '../Profile/components/ProfileBlock'

export const ProfileCard = () => {
    return (
        <Box
            sx={{
                gridArea: 'profile',
            }}
        >
            <ProfileBlock />
        </Box>
    )
}
